import React from "react";

export const InventoryItemsKanbanConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
          path: "/asset-management/inventory",
          component: React.lazy(() => import("./InventoryItemsKanban"))
    }
  ]
};
